'use strict';

import React from 'react';
import UserStore from '../stores/UserStore';
import StampStore from '../stores/StampStore';
import ZineStore from '../stores/ZineStore';
import ImageStore from '../stores/ImageStore';
import UserInfo from '../organisms/UserInfo';
import UserLink from '../atoms/UserLink';
import StampLink from '../atoms/StampLink';
import ZineLink from '../atoms/ZineLink';
import DraftLink from '../atoms/DraftLink';
import Button from '../atoms/Button';
import PureRenderMixin from '../mixins/PureRenderMixin';
import getThumbnailUrl from '../utils/getThumbnailUrl';
import ClassNameMixin from '../mixins/ClassNameMixin';
import TimeAgo from '../organisms/TimeAgo';
import getZineThumbnail from '../utils/getZineThumbnail';
import getUserThumbnail from '../utils/getUserThumbnail';
import ActivityActionCreators from '../actions/ActivityActionCreators';
import ZineActionCreators from '../actions/ZineActionCreators';
import UserActionCreators from '../actions/UserActionCreators';
import Link from '../atoms/Link';
import Icon from '../atoms/Icon';
import ActivityTypes from '../constants/ActivityTypes';
import createStoreMixin from '../mixins/createStoreMixin';
import { transitionTo } from '../router';
import { PropTypes } from 'react';
import getStampSegment from '../utils/getStampSegment';

import './Activity.less';

var STAMPSY_AVATAR = {
  url: '//stampsy-eu-1.s3.amazonaws.com/uploads/10/06/2014/user/9/d8300036-1d75-4c4d-8210-98248a6d2244.jpg'
};

var Activity = React.createClass({
  mixins: [
    ClassNameMixin,
    createStoreMixin(UserStore, ZineStore, ImageStore),
    PureRenderMixin
  ],

  propTypes: {
    activity: PropTypes.object.isRequired
  },

  getCSSModifiers() {
    return [
      this.props.activity.isSeen && 'seen',
      this.isExpandable() && 'expandable'
    ];
  },

  getStateFromStores(props) {
    var { actorIds, objectIds, targetIds, verb } = props.activity,
        objectStore,
        targetStore;

    function getObjectStore(verb) {
      switch (verb) {
      case ActivityTypes.STAMP_LIKED:
      case ActivityTypes.STAMP_SUBMITTED_TO_ZINE:
      case ActivityTypes.STAMP_APPROVED_IN_ZINE:
      case ActivityTypes.STAMP_REJECTED_FROM_ZINE:
      case ActivityTypes.STAMP_ADDED_TO_ZINE:
      case ActivityTypes.STAMP_IN_TRENDING:
      case ActivityTypes.DRAFT_FEEDBACK:
        return StampStore;
      case ActivityTypes.ZINE_FOLLOWED:
      case ActivityTypes.WELCOME_MESSAGE:
        return ZineStore;
      case ActivityTypes.COLLECTED_IMAGE_PUBLISHED:
        return ImageStore;
      }
    }

    function getTargetStore(verb) {
      switch (verb) {
      case ActivityTypes.STAMP_SUBMITTED_TO_ZINE:
      case ActivityTypes.STAMP_APPROVED_IN_ZINE:
      case ActivityTypes.STAMP_REJECTED_FROM_ZINE:
      case ActivityTypes.STAMP_ADDED_TO_ZINE:
        return ZineStore;
      case ActivityTypes.COLLECTED_IMAGE_PUBLISHED:
        return StampStore;
      }
    }

    objectStore = getObjectStore(verb);
    targetStore = getTargetStore(verb);

    return {
      actors: actorIds.map(UserStore.get),
      objects: objectStore && objectIds.map(objectStore.get),
      targets: targetStore && targetIds.map(targetStore.get)
    };
  },

  isExpandable() {
    var activity = this.props.activity;

    switch (activity.verb) {
    case ActivityTypes.STAMP_LIKED:
      return activity.actorIds.length > 2;
    case ActivityTypes.ZINE_FOLLOWED:
      return activity.objectIds.length > 2;
    case ActivityTypes.USER_FOLLOWED:
      return activity.actorIds.length > 1;
    }
  },

  getIcon(activity) {
    var color,
        icon,
        classes;

    switch (activity.verb) {
    case ActivityTypes.STAMP_LIKED:
      color = 'red';
      icon = <Icon name='like' mode='fill' size='xxsmall' />;
      break;

    case ActivityTypes.STAMP_ADDED_TO_ZINE:
      color = 'green';
      icon = <Icon name='plus' mode='stroke' size='xxsmall' />;
      break;

    case ActivityTypes.STAMP_APPROVED_IN_ZINE:
      color = 'green';
      icon = <Icon name='check' mode='stroke' size='xxsmall' />;
      break;

    case ActivityTypes.STAMP_REJECTED_FROM_ZINE:
      color = 'red';
      icon = <Icon name='cross' mode='stroke' size='xxsmall' />;
      break;

    case ActivityTypes.STAMP_SUBMITTED_TO_ZINE:
      color = 'yellow';
      icon = <Icon name='clock' mode='stroke' size='xxsmall' />;
      break;

    case ActivityTypes.ZINE_FOLLOWED:
    case ActivityTypes.USER_FOLLOWED:
      return null;

    case ActivityTypes.STAMP_IN_TRENDING:
      color = 'green';
      icon = <Icon name='trending' mode='stroke' size='xxsmall' />;
      break;

    default:
      return null;
    }

    classes = ['Activity-icon', 'Activity-icon--' + color].join(' ');

    return (
      <div className={classes}>
        {icon}
      </div>
    );
  },

  getAvatar(activity) {
    const devicePixelRatio = (typeof window !== 'undefined') ? window.devicePixelRatio : 1;

    function renderDefaultAvatar() {
      var thumbnailUrl = getThumbnailUrl(STAMPSY_AVATAR, {
        mode: 'scale_crop',
        width: 44 * Math.round(devicePixelRatio),
        height: 44 * Math.round(devicePixelRatio)
      });

      return (
        <img className='Activity-avatarImage' src={thumbnailUrl} />
      );
    }

    function renderUserAvatar(user) {
      var thumbnailUrl = getThumbnailUrl(getUserThumbnail(user), {
        width: 44 * Math.round(devicePixelRatio),
        height: 44 * Math.round(devicePixelRatio),
        allowExternal: true,
        allowEmpty: true,
        mode: 'scale_crop'
      });

      return (
        <UserLink user={user} showTitle>
          <img className='Activity-avatarImage' src={thumbnailUrl} />
        </UserLink>
      );
    }

    function renderZineAvatar(zine) {
      var thumbnailUrl = getThumbnailUrl(getZineThumbnail(zine), {
        width: 44 * Math.round(devicePixelRatio),
        height: 44 * Math.round(devicePixelRatio),
        mode: 'scale_crop'
      });

      return (
        <ZineLink zine={zine} showTitle>
          <img className='Activity-avatarImage' src={thumbnailUrl} />
        </ZineLink>
      );
    }

    switch (activity.verb) {
    case ActivityTypes.STAMP_IN_TRENDING:
    case ActivityTypes.WELCOME_MESSAGE:
      return renderDefaultAvatar();

    case ActivityTypes.STAMP_APPROVED_IN_ZINE:
    case ActivityTypes.STAMP_ADDED_TO_ZINE:
    case ActivityTypes.STAMP_REJECTED_FROM_ZINE:
      return renderZineAvatar(this.state.targets[0]);

    case ActivityTypes.STAMP_SUBMITTED_TO_ZINE:
    case ActivityTypes.DRAFT_FEEDBACK:
      if (activity.extraContext.isGrouping) {
        return renderDefaultAvatar();
      }
      return renderUserAvatar(this.state.actors[0]);

    case ActivityTypes.STAMP_LIKED:
    case ActivityTypes.ZINE_FOLLOWED:
    case ActivityTypes.USER_FOLLOWED:
    case ActivityTypes.COLLECTED_IMAGE_PUBLISHED:
      return renderUserAvatar(this.state.actors[0]);
    }
  },

  getPreview(activity) {
    const devicePixelRatio = (typeof window !== 'undefined') ? window.devicePixelRatio : 1;

    function getStampPreview(stamp) {
      var thumbnailUrl = getThumbnailUrl(stamp.thumbnail, {
        width: 52 * Math.round(devicePixelRatio),
        height: 44 * Math.round(devicePixelRatio),
        mode: 'scale_crop'
      });

      return (
        <StampLink stamp={stamp} showTitle>
          <img className='Activity-stampPreview'
               src={thumbnailUrl} />
        </StampLink>
      );
    }

    function getDraftPreview(draft) {
      var thumbnailUrl = getThumbnailUrl(draft.thumbnail, {
        width: 52 * Math.round(devicePixelRatio),
        height: 44 * Math.round(devicePixelRatio),
        mode: 'scale_crop',
        allowEmpty: true
      });

      return (
        <DraftLink draft={draft}
                   showTitle>
          {thumbnailUrl ?
            <img className='Activity-stampPreview'
                 src={thumbnailUrl} /> :
            <div className='Activity-stampPreview' />
          }
        </DraftLink>
      );
    }

    function getZinePreview(zine) {
      var thumbnailUrl = getThumbnailUrl(getZineThumbnail(zine), {
        width: 44 * Math.round(devicePixelRatio),
        height: 44 * Math.round(devicePixelRatio),
        mode: 'scale_crop'
      });

      return (
        <ZineLink zine={zine} showTitle>
          <img className='Activity-zinePreview'
               src={thumbnailUrl} />
        </ZineLink>
      );
    }

    function getUserPreview(user) {
      var thumbnailUrl = getThumbnailUrl(getUserThumbnail(user), {
        width: 44 * Math.round(devicePixelRatio),
        height: 44 * Math.round(devicePixelRatio),
        mode: 'scale_crop'
      });

      return (
        <UserLink user={user} showTitle>
          <img className='Activity-userPreview'
               src={thumbnailUrl} />
        </UserLink>
      );
    }

    function getImagePreview(image, stamp) {
      var thumbnailUrl = getThumbnailUrl(image, {
        width: 44 * Math.round(devicePixelRatio),
        height: 44 * Math.round(devicePixelRatio),
        mode: 'scale_crop'
      });

      return (
        <StampLink stamp={stamp} showTitle>
          <img className='Activity-imagePreview'
               src={thumbnailUrl} />
        </StampLink>
      );
    }

    switch (activity.verb) {
    case ActivityTypes.STAMP_LIKED:
    case ActivityTypes.STAMP_APPROVED_IN_ZINE:
    case ActivityTypes.STAMP_REJECTED_FROM_ZINE:
    case ActivityTypes.STAMP_IN_TRENDING:
    case ActivityTypes.STAMP_ADDED_TO_ZINE:
      return getStampPreview(this.state.objects[0]);

    case ActivityTypes.DRAFT_FEEDBACK:
      return getDraftPreview(this.state.objects[0]);

    case ActivityTypes.STAMP_SUBMITTED_TO_ZINE:
      return getZinePreview(this.state.targets[0]);

    case ActivityTypes.ZINE_FOLLOWED:
    case ActivityTypes.WELCOME_MESSAGE:
      return getZinePreview(this.state.objects[0]);

    case ActivityTypes.USER_FOLLOWED:
      return getUserPreview(UserStore.getMe());

    case ActivityTypes.COLLECTED_IMAGE_PUBLISHED:
      return getImagePreview(this.state.objects[0], this.state.targets[0]);
    }
  },

  getAction(activity) {
    function renderReviewButton(stamp, zine) {
      function handleClick() {
        transitionTo('zinePendingStamp', {
          zineSlug: zine.slug,
          stampSegment: getStampSegment(stamp)
        });
      }

      return (
        <Button color='yellow'
                size='small'
                fill
                context='Activity'
                onClick={handleClick}>
          Review Submission
        </Button>
      );
    }

    function renderZineFollowButton(zine) {
      function handleClick() {
        ZineActionCreators.followZine(zine.slug);
      }

      if (zine.isSubscribed) {
        return;
      }

      return (
        <Button color='green'
                size='small'
                fill
                context='Activity' onClick={handleClick}>
          Follow Collection
        </Button>
      );
    }

    function renderUserFollowButton(user) {
      function handleClick() {
        UserActionCreators.followUser(user.id);
      }

      if (user.isSubscribed) {
        return;
      }

      return (
        <Button color='green'
                size='small'
                fill
                context='Activity' onClick={handleClick}>
          {'Follow ' + user.name.split(' ')[0]}
        </Button>
      );
    }

    switch (activity.verb) {
    case ActivityTypes.STAMP_SUBMITTED_TO_ZINE:
      return renderReviewButton(this.state.objects[0], this.state.targets[0]);
    case ActivityTypes.STAMP_ADDED_TO_ZINE:
      return renderZineFollowButton(this.state.targets[0]);
    case ActivityTypes.WELCOME_MESSAGE:
      return renderZineFollowButton(this.state.objects[0]);
    case ActivityTypes.USER_FOLLOWED:
      return renderUserFollowButton(this.state.actors[0]);
    }
  },

  getMessage(activity) {
    const { actors } = this.state;
    let stamp, stamps, stampProps, zine, draft, message;

    switch (activity.verb) {
    case ActivityTypes.STAMP_LIKED:
      stamp = this.state.objects[0];
      if (actors.length > 2) {
        return (
          <span>
            <UserLink user={actors[0]} /> and <Link bold onClick={this.handleExpandClick}>{actors.length - 1} others</Link> like your Stamp <StampLink stamp={stamp} bold />.
          </span>
        );
      } else if (actors.length === 2) {
        return (
          <span>
            <UserLink user={actors[0]} /> and <UserLink user={actors[1]} /> like your Stamp <StampLink stamp={stamp} bold />.
          </span>
        );
      } else {
        return (
          <span>
            <UserLink user={actors[0]} /> likes your Stamp <StampLink stamp={stamp} bold />.
          </span>
        );
      }
      break;

    case ActivityTypes.STAMP_SUBMITTED_TO_ZINE:
      zine = this.state.targets[0];
      stamps = this.state.objects;
      stampProps = {
        routeName: 'zinePendingStamp',
        routeParams: { zineSlug: activity.targetIds[0] }
      };

      if (activity.extraContext.isGrouping) {
        if (stamps.length > 2) {
          return (
            <span>
              <StampLink stamp={stamps[0]} bold {...stampProps} /> and <Link bold onClick={this.handleExpandClick}>{stamps.length - 1} more stamps</Link> are waiting for your approval to <ZineLink zine={zine} bold />.
            </span>
          );
        } else if (stamps.length === 2) {
          return (
            <span>
              <StampLink stamp={stamps[0]} bold {...stampProps} /> and <StampLink stamp={stamps[1]} bold {...stampProps} /> are waiting for your approval to <ZineLink zine={zine} bold />.
            </span>
          );
        } else {
          return (
            <span>
              <StampLink stamp={stamps[0]} bold {...stampProps} /> by <UserLink user={actors[0]} bold /> is waiting for your approval to <ZineLink zine={zine} bold />.
            </span>
          );
        }
      } else {
        if (stamps.length > 2) {
          return (
            <span>
              <StampLink stamp={stamps[0]} bold {...stampProps} /> and <Link bold onClick={this.handleExpandClick}>{stamps.length - 1} more stamps</Link> were submitted to <ZineLink zine={zine} bold />.
            </span>
          );
        } else if (stamps.length === 2) {
          return (
            <span>
              <StampLink stamp={stamps[0]} bold {...stampProps} /> and <StampLink stamp={stamps[1]} bold {...stampProps} /> were submitted to <ZineLink zine={zine} bold />.
            </span>
          );
        } else {
          return (
            <div>
              <div>
                <UserLink user={actors[0]} bold /> submitted <StampLink stamp={stamps[0]} bold {...stampProps} /> to <ZineLink zine={zine} bold />.
              </div>
            </div>
          );
        }
      }
      break;

    case ActivityTypes.DRAFT_FEEDBACK:
      draft = this.state.objects[0];
      message = activity.extraContext.message;
      return (
        <span>
          <UserLink user={actors[0]} /> sent you feedback on <DraftLink draft={draft} emptyTitle='your draft' bold />:
          <div>{message}</div>
        </span>
      );

    case ActivityTypes.STAMP_APPROVED_IN_ZINE:
      zine = this.state.targets[0];
      stamp = this.state.objects[0];
      message = activity.extraContext.message;
      return (
        <span>
          Your submission to <ZineLink zine={zine} bold /> has been approved.<br />

          {message && (
            <span>
              Curator sent you a message regarding <StampLink stamp={stamp} bold />:

              <UserInfo user={actors[0]}
                        size='xsmall'
                        context='Activity'>
                “{message}”
              </UserInfo>
            </span>
          )}
        </span>
      );

    case ActivityTypes.STAMP_REJECTED_FROM_ZINE:
      zine = this.state.targets[0];
      stamp = this.state.objects[0];
      message = activity.extraContext.message;
      return (
        <span>
          Your submission to <ZineLink zine={zine} bold /> has been declined.<br />

          {message && (
            <span>
              Curator sent you a message regarding <StampLink stamp={stamp} bold />:

              <UserInfo user={actors[0]}
                        size='xsmall'
                        context='Activity'>
                “{message}”
              </UserInfo>
            </span>
          )}
        </span>
      );

    case ActivityTypes.ZINE_FOLLOWED:
      zine = this.state.objects[0];
      if (actors.length > 2) {
        return (
          <span>
            <UserLink user={actors[0]} /> and <Link bold onClick={this.handleExpandClick}>{actors.length - 1} others</Link> started following your Collection <ZineLink zine={zine} bold />.
          </span>
        );
      } else if (actors.length === 2) {
        return (
          <span>
            <UserLink user={actors[0]} /> and <UserLink user={actors[1]} /> started following your Collection <ZineLink zine={zine} bold />.
          </span>
        );
      } else {
        return (
          <span>
            <UserLink user={actors[0]} /> started following your Collection <ZineLink zine={zine} bold />.
          </span>
        );
      }
      break;

    case ActivityTypes.USER_FOLLOWED:
      if (actors.length > 2) {
        return (
          <span>
            <UserLink user={actors[0]} /> and <Link bold onClick={this.handleExpandClick}>{actors.length - 1} others</Link> started following you.
          </span>
        );
      } else if (actors.length === 2) {
        return (
          <span>
            <UserLink user={actors[0]} /> and <Link bold onClick={this.handleExpandClick}>1 other</Link> started following you.
          </span>
        );
      } else {
        return (
          <span>
            <UserLink user={actors[0]} /> started following you.
          </span>
        );
      }
      break;

    case ActivityTypes.STAMP_ADDED_TO_ZINE:
      zine = this.state.targets[0];
      stamp = this.state.objects[0];
      return (
        <span>
          Your Stamp <StampLink stamp={stamp} bold /> was added to Collection <ZineLink zine={zine} bold />.
        </span>
      );

    case ActivityTypes.STAMP_IN_TRENDING:
      stamp = this.state.objects[0];
      return (
        <span>
          Your stamp <StampLink stamp={stamp} bold /> is now trending on Stampsy, as it has been viewed more than {activity.extraContext.viewCount} times.
        </span>
      );

    case ActivityTypes.WELCOME_MESSAGE:
      zine = this.state.objects[0];
      return (
        <span>
          Welcome to Stampsy! Learn more about how everything works by following <ZineLink zine={zine} bold>About Stampsy</ZineLink> collection.
        </span>
      );

    case ActivityTypes.COLLECTED_IMAGE_PUBLISHED:
      stamp = this.state.targets[0];
      return (
        <span>
          <UserLink user={actors[0]} /> credited your image in their Stamp <StampLink stamp={stamp} bold />.
        </span>
      );
    }
  },

  render() {
    var activity = this.props.activity,
        message = this.getMessage(activity),
        action = this.getAction(activity),
        preview = this.getPreview(activity),
        avatar = this.getAvatar(activity),
        icon = this.getIcon(activity),
        time;

    time = (
      <TimeAgo className='Activity-time'
               date={activity.created} />
    );

    return (
      <div className={this.getClassName()}>
        <div className='Activity-avatar'>{avatar}{icon}</div>
        <div className='Activity-message'>{message}{action}{time}</div>
        <div className='Activity-thumbnail utils--hideOnMobile'>{preview}</div>
      </div>
    );
  },

  handleExpandClick() {
    if (!this.isExpandable()) {
      return;
    }

    ActivityActionCreators.expandActivity(this.props.activity.id);
  }
});

export default Activity;



/** WEBPACK FOOTER **
 ** ./molecules/Activity.jsx
 **/